'use strict';

(function ($) {
  $.ajaxSync = function (url, method, data, successCallBack, errorCallBack) {
    $.ajax({
      url: url,
      type: method,
      data: data,
      async: false,
      success: function (res) {
        if ($.isFunction(successCallBack)) {
          successCallBack(res);
        }
      },

      error: function (xhr, status) {
        if ($.isFunction(errorCallBack)) {
          errorCallBack(xhr, status);
        }
      }
    });
  };

  $.getSync = function (url, successCallBack, errorCallBack) {
    $.ajaxSync(url, 'GET', '', successCallBack, errorCallBack);
  };

  $.postSync = function (url, data, successCallBack, errorCallBack) {
    $.ajaxSync(url, 'POST', data, successCallBack, errorCallBack);
  };
})(jQuery);
